import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Grid } from "@mui/material";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { SelectButton } from "primereact/selectbutton";
import {
  addRiskAssessment,
  updateRiskAssessment,
} from "../../service/riskAssessmentService";
import { Calendar } from "primereact/calendar";
import dayjs from "dayjs";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import MultiDropdownApi from "../../components/MultiDropdownApi";

export default function RiskAssessmentAdd(modalProps: any) {
  const details = modalProps?.details;

  const client_id = modalProps?.client;
  const site = modalProps?.site;

  const record_id = modalProps?.record_id;
  const record_type = modalProps?.type;

  async function Add() {
    if (!!site) return;
    let updateDetails: any = {
      hazard,
      description,
      responsible,
      likelihood,
      consequence,
      rating,
      after_likelihood: afterLikelihood,
      after_consequence: afterConsequence,
      after_rating: afterRating,
      note,
      review_date: reviewDate,
    };
    if (client_id) {
      updateDetails.type = type;
      updateDetails.record_id = type == "Generic" ? undefined : recordId;
    }
    modalProps.setGlobalLoading(true);
    if (modalProps.id) {
      updateRiskAssessment(updateDetails, modalProps.id)
        .then((r: any) => {
          modalProps.toast.current.show({
            severity: "success",
            summary: "Risk Updated Successfully",
            life: 3000,
          });
          modalProps.setVisible(false);
          modalProps.setGlobalLoading(false);
          modalProps.setReload(!modalProps.reload);
        })
        .catch((error) => {
          modalProps.toast.current.show({
            severity: "error",
            summary: "Failed to Updated Risk",
            life: 3000,
          });
          modalProps.setGlobalLoading(false);
        });
    } else {
      if (client_id) {
        updateDetails.client_id = client_id;
      }
      addRiskAssessment(updateDetails)
        .then((r: any) => {
          modalProps.toast.current.show({
            severity: "success",
            summary: "Risk Created Successfully",
            life: 3000,
          });
          modalProps.setVisible(false);
          modalProps.setGlobalLoading(false);
          modalProps.setReload(!modalProps.reload);
        })
        .catch((error) => {
          modalProps.toast.current.show({
            severity: "error",
            summary: "Failed to Create Risk",
            life: 3000,
          });
          modalProps.setGlobalLoading(false);
        });
    }
  }

  const [hazard, setHazard] = React.useState(details?.hazard || []);
  const [hazardObject, setHazardObject] = React.useState<any[]>([]);
  const [note, setNote] = React.useState(details?.note || "");
  const [description, setDescription] = React.useState(
    details?.description || ""
  );
  const [responsible, setResponsible] = React.useState(
    details?.responsible || ""
  );
  const [reviewDate, setReviewDate] = React.useState(
    details?.review_date
      ? new Date(details?.review_date)
      : dayjs().add(1, "year").toDate()
  );
  const [controlMeasures, setControlMeasures] = React.useState<string[]>([]);
  const [activeStep, setActiveStep] = React.useState(0);
  const stepperRef = React.useRef<any>(null);

  async function Next() {
    setActiveStep(activeStep + 1);
    stepperRef?.current?.nextCallback();
  }

  async function Back() {
    setActiveStep(activeStep - 1);
    stepperRef?.current?.prevCallback();
  }

  const likelihoodOptions = [
    {
      value: 1,
      label: "Rare",
      color: "#2DD55B",
    },
    {
      value: 2,
      label: "Unlikely",
      color: "#53A048",
    },
    {
      value: 3,
      label: "Possible",
      color: "#796B35",
    },
    {
      value: 4,
      label: "Likely",
      color: "#9F3522",
    },
    {
      value: 5,
      label: "Almost Certain",
      color: "#C5000F",
    },
  ];
  const afterLikelihoodOptions = [
    {
      value: 1,
      label: "Rare",
      color: "#2DD55B",
      selected: false,
    },
    {
      value: 2,
      label: "Unlikely",
      color: "#53A048",
      selected: false,
    },
    {
      value: 3,
      label: "Possible",
      color: "#796B35",
      selected: false,
    },
    {
      value: 4,
      label: "Likely",
      color: "#9F3522",
      selected: false,
    },
    {
      value: 5,
      label: "Almost Certain",
      color: "#C5000F",
      selected: false,
    },
  ];
  const [likelihood, setLikelihood] = React.useState(details?.likelihood || 0);
  const [afterLikelihood, setAfterLikelihood] = React.useState(
    details?.after_likelihood || 0
  );

  const consequenceOptions = [
    {
      value: 1,
      label: "Minor",
      color: "#2DD55B",
    },
    {
      value: 2,
      label: "Moderate",
      color: "#53A048",
    },
    {
      value: 3,
      label: "Serious",
      color: "#796B35",
    },
    {
      value: 4,
      label: "Major",
      color: "#9F3522",
    },
    {
      value: 5,
      label: "Catastrophic ",
      color: "#C5000F",
    },
  ];
  const afterConsequenceOptions = [
    {
      value: 1,
      label: "Minor",
      color: "#2DD55B",
      selected: false,
    },
    {
      value: 2,
      label: "Moderate",
      color: "#53A048",
      selected: false,
    },
    {
      value: 3,
      label: "Serious",
      color: "#796B35",
      selected: false,
    },
    {
      value: 4,
      label: "Major",
      color: "#9F3522",
      selected: false,
    },
    {
      value: 5,
      label: "Catastrophic ",
      color: "#C5000F",
      selected: false,
    },
  ];
  const [consequence, setConsequence] = React.useState(
    details?.consequence || 0
  );
  const [afterConsequence, setAfterConsequence] = React.useState(
    details?.after_consequence || 0
  );

  const ratingOptions = [
    {
      value: 1,
      label: "Low Risk",
      color: "#2DD55B",
    },
    {
      value: 2,
      label: "Possible Risk",
      color: "#53A048",
    },
    {
      value: 3,
      label: "Medium Risk",
      color: "#796B35",
    },
    {
      value: 4,
      label: "High Risk",
      color: "#9F3522",
    },
    {
      value: 5,
      label: "Critical Risk",
      color: "#C5000F",
    },
  ];
  const afterRatingOptions = [
    {
      value: 1,
      label: "Low Risk",
      color: "#2DD55B",
      selected: false,
    },
    {
      value: 2,
      label: "Possible Risk",
      color: "#53A048",
      selected: false,
    },
    {
      value: 3,
      label: "Medium Risk",
      color: "#796B35",
      selected: false,
    },
    {
      value: 4,
      label: "High Risk",
      color: "#9F3522",
      selected: false,
    },
    {
      value: 5,
      label: "Critical Risk",
      color: "#C5000F",
      selected: false,
    },
  ];
  const [rating, setRating] = React.useState(0);
  const [afterRating, setAfterRating] = React.useState(0);

  const [type, setType] = React.useState(
    record_type || details?.type || "Generic"
  );
  const types = [{ id: "Generic" }, { id: "Equipment" }];
  const [recordId, setRecordId] = React.useState(
    record_id || details?.record_id
  );

  const stepperArray = [
    "Details",
    "Risk",
    "Control Measures",
    "After Control Risk",
  ];

  if (client_id && !record_id) {
    stepperArray.splice(1, 0, "Type");
  }

  const justifyTemplate = (option: any) => {
    return (
      <div>
        <label style={{ color: option.color }}>{option.label}</label>
        {option.selected ? (
          <label
            style={{
              position: "absolute",
              top: "0",
              right: "5px",
              color: "red",
              fontSize: "x-large",
            }}
          >
            *
          </label>
        ) : (
          ""
        )}
      </div>
    );
  };

  React.useEffect(() => {
    const sum = likelihood * consequence;
    if (sum < 4) {
      setRating(1);
      return;
    }
    if (sum < 12) {
      setRating(2);
      return;
    }
    if (sum < 15) {
      setRating(3);
      return;
    }
    if (sum < 25) {
      setRating(4);
      return;
    }
    setRating(5);
  }, [likelihood, consequence]);

  React.useEffect(() => {
    const sum = afterLikelihood * afterConsequence;
    if (sum < 4) {
      setAfterRating(1);
      return;
    }
    if (sum < 12) {
      setAfterRating(2);
      return;
    }
    if (sum < 15) {
      setAfterRating(3);
      return;
    }
    if (sum < 25) {
      setAfterRating(4);
      return;
    }
    setAfterRating(5);
  }, [afterLikelihood, afterConsequence]);

  React.useEffect(() => {

    const control_measure_list = hazardObject?.map((hazard: any) => {
      return hazard.control_measure_list;
    });

    if (control_measure_list) {
      let tempControlMeasures: string[] = [];
      control_measure_list.forEach((list: string) => {
        if (list) {
          tempControlMeasures = tempControlMeasures.concat(list.split(","));
        }
      });
      setControlMeasures(tempControlMeasures);
    } else {
      setControlMeasures([]);
    }
  }, [hazardObject]);

  return (
    <React.Fragment>
      <Stepper ref={stepperRef} linear={true}>
        <StepperPanel header="Details">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MultiDropdownApi
                apiPath="risk-hazard"
                optionLabel="name"
                optionValue="id"
                label="Hazard"
                selectedData={hazard}
                setSelectedData={setHazard}
                setSelectedObject={setHazardObject}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Risk Outcome</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputTextarea
                    value={description}
                    placeholder="Risk Outcome"
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={client_id ? 6 : 12}>
              <DropdownApi
                apiPath="appointments"
                optionLabel="name"
                optionValue="id"
                label="Responsible"
                selectedData={responsible}
                setSelectedData={setResponsible}
              />
            </Grid>
            {client_id ? (
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Review Date</FormLabel>
                  <FormControl
                    sx={{
                      display: { sm: "flex-column", md: "flex-row" },
                      gap: 2,
                    }}
                  >
                    <Calendar
                      value={reviewDate}
                      onChange={(e) => setReviewDate(e.value || new Date())}
                      showIcon
                    />
                  </FormControl>
                </FormControl>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </StepperPanel>
        {client_id && !record_id ? (
          <StepperPanel header="Type">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl>
                  <FormLabel>Type</FormLabel>
                  <FormControl
                    sx={{
                      display: { sm: "flex-column", md: "flex-row" },
                      gap: 2,
                    }}
                  >
                    <Dropdown
                      className="PrimeSmallInput"
                      style={{ fontSize: "small", padding: 0 }}
                      value={type}
                      onChange={(e) => setType(e.value)}
                      options={types}
                      optionLabel="id"
                      optionValue="id"
                      placeholder="Select a Type"
                    />
                  </FormControl>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                {type == "Equipment" ? (
                  <DropdownApi
                    apiPath="equipment"
                    optionLabel="name"
                    optionValue="id"
                    label="Equipment"
                    selectedData={recordId}
                    setSelectedData={setRecordId}
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </StepperPanel>
        ) : null}
        <StepperPanel header="Risk Score">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Likelihood</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <SelectButton
                    value={likelihood}
                    onChange={(e) => setLikelihood(e.value)}
                    itemTemplate={justifyTemplate}
                    options={likelihoodOptions}
                    optionLabel="label"
                    optionValue="value"
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Consequence</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <SelectButton
                    value={consequence}
                    onChange={(e) => setConsequence(e.value)}
                    itemTemplate={justifyTemplate}
                    options={consequenceOptions}
                    optionLabel="label"
                    optionValue="value"
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Rating</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <SelectButton
                    value={rating}
                    disabled
                    onChange={(e) => setRating(e.value)}
                    itemTemplate={justifyTemplate}
                    options={ratingOptions}
                    optionLabel="label"
                    optionValue="value"
                  />
                </FormControl>
              </FormControl>
            </Grid>
          </Grid>
        </StepperPanel>
        <StepperPanel header="Control Measures">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Control Measures</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                </FormControl>
              </FormControl>
            </Grid>
            {controlMeasures && controlMeasures.map((checklist: any, index: number) => {
              return (
                <Grid item xs={12} key={index}>
                  <IconField>
                    <InputText
                      value={checklist}
                      readOnly={true}
                      style={{ width: "100%" }}
                      type="text"
                      className="p-inputtext-sm PrimeSmallInput"
                    />
                  </IconField>
                </Grid>
              );
            })}
          </Grid>
        </StepperPanel>
        <StepperPanel header="After Control Risk Score">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Likelihood</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <SelectButton
                    value={afterLikelihood}
                    onChange={(e) => setAfterLikelihood(e.value)}
                    itemTemplate={justifyTemplate}
                    options={afterLikelihoodOptions.map((e) => {
                      e.selected = e.value === likelihood;
                      return e;
                    })}
                    optionLabel="label"
                    optionValue="value"
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Consequence</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <SelectButton
                    value={afterConsequence}
                    onChange={(e) => setAfterConsequence(e.value)}
                    itemTemplate={justifyTemplate}
                    options={afterConsequenceOptions.map((e) => {
                      e.selected = e.value === consequence;
                      return e;
                    })}
                    optionLabel="label"
                    optionValue="value"
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Rating</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <SelectButton
                    value={afterRating}
                    disabled
                    onChange={(e) => setAfterRating(e.value)}
                    itemTemplate={justifyTemplate}
                    options={afterRatingOptions.map((e) => {
                      e.selected = e.value === rating;
                      return e;
                    })}
                    optionLabel="label"
                    optionValue="value"
                  />
                </FormControl>
              </FormControl>
            </Grid>
          </Grid>
        </StepperPanel>
      </Stepper>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          {activeStep > 0 ? (
            <Button
              type="button"
              icon="pi pi-arrow-left"
              label="Back"
              className="p-button-outlined"
              size="small"
              style={{ position: "absolute", fontSize: "small", right: 100 }}
              onClick={() => Back()}
            />
          ) : (
            ""
          )}
          {activeStep != stepperArray.length - 1 ? (
            <Button
              type="button"
              icon="pi pi-arrow-right"
              label="Next"
              className="p-button-outlined"
              size="small"
              style={{ position: "absolute", fontSize: "small", right: 0 }}
              onClick={() => Next()}
            />
          ) : (
            <Button
              type="button"
              icon="pi pi-save"
              label="Save"
              className="p-button-outlined"
              size="small"
              style={{
                position: "absolute",
                fontSize: "small",
                right: 0,
                color: "#2dd36f",
              }}
              onClick={() => Add()}
            />
          )}
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
